/*
 *  Copyright
 *
 *  Tegona SA
 *
 *  quinto © 2021, Tegona SA
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
*/

import * as constants from 'constants/User'

const initialState = {
  user: {}
}

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case constants.SET_USER:
      return {
        ...state,
        user: action.value,
      }

    default:
      return state
  }
}


const mapStateToProps = (state) => ({
  user: state.User.user,
})


// WEBPACK FOOTER //
// ./src/reducers/User.js